module.exports = __webpack_public_path__ + "static/media/compressor.20fed5a4.png";